import { ProjectsScheduledBathesListAPI } from 'ducks/types/api-types';
import { normalizeScheduledBatch } from 'ducks/utils';

export function normalizeScheduledBatches(data: ProjectsScheduledBathesListAPI[]) {
  return data.map((definition) => normalizeScheduledBatch(definition)).sortObject('scheduled_batch_name', 'desc');
}
